import React  from 'react';
import forms from './Forms/index';
import { getPageItem } from '../../modules/Api';
import PageForm from './form';

function prepareForEdit(data){
    return data.data.page;
};

class EditPage  extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            slug: null,
            submitted: false
        }

    }
    componentDidMount() {
        this.fetchPageDetail();
    }

    fetchPageDetail() {
        const slug = this.props.match.params.slug;
        getPageItem(slug, (data) => {this.setState({data: prepareForEdit(data), slug: slug})});
    }

    render(){
        if(!this.state.slug || !this.state.data){
            return <div>منتظر بمانید</div>;
        }
        if(forms[this.state.slug] == undefined){
            return <div>فرم یافت نشد</div>;
        }
        return <PageForm handler={forms[this.state.slug]} initialData={this.state.data} submitted={this.state.submitted}/>;
    }
}

export default EditPage;


// WEBPACK FOOTER //
// ./src/containers/Pages/edit.js